function chmPointsSelector($selector, min, max) {
    var _this, STATUS;

    (() => {
        min = parseInt(min, 10);
        if (isNaN(min)) {
            min = 1;
        }
        max = parseInt(max, 10);
        if (isNaN(max)) {
            max = 999;
        }

        STATUS = {
            value: 0,
            onChange: null,
            min: (min < max) ? min : max,
            max: (max > min) ? max : min
        };
    })();

    function checkValue() {
        if (!isNaN(STATUS.value) && (STATUS.value >= STATUS.min) && (STATUS.value <= STATUS.max)) {
            return;
        }

        if (isNaN(STATUS.value) || (STATUS.value < STATUS.min)) {
            STATUS.value = STATUS.min;
        }

        if ((STATUS.value > STATUS.max)) {
            STATUS.value = STATUS.max;
        }

        update();
    }

    function update() {
        $selector.attr('data-value', STATUS.value);
        $selector.find('input').val(STATUS.value);
    }

    function triggerChange() {
        if (STATUS.onChange) {
            try {
                STATUS.onChange.call(_this, STATUS.value);
            } catch(e) {
                console.error(e);
            }
        }
    }

    $selector.find('input').on('input change', function() {
        STATUS.value = parseInt(this.value, 10);
        checkValue();
        update();
        triggerChange();
    }).on('focus', function() {
        this.select();
    });


    $selector.find('[data-change-value]').on('click', function() {
        var $current, $next, currentIndex, nextIndex, step;

        step = parseInt(this.dataset.changeValue, 10);
        if (isNaN(step)) {
            step = 1;
        }

        STATUS.value += step;

        checkValue();
        update();
        triggerChange();
    });

    _this = {
        set: function(value) {
            STATUS.value = parseInt(value, 10);
            checkValue();
            update();
            return _this;
        },
        get: function() {
            return STATUS.value;
        },
        onChange: function(callback) {
            STATUS.onChange = callback;
            return _this;
        }
    }

    return _this;
}